export default __webpack_public_path__ + "static/media/Commander's Boots of the Watchtowers.b143a239.jpg";